import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  IAdvertisingChannelsRequest,
  IAdvertisingChannelsResponse,
  IAdvertisingDashboardRequest,
  IAdvertisingDashboardResponse,
  IAdvertisingPostDetailRequest,
  IAdvertisingPostDetailResponse,
  IAdvertisingPostsRequest,
  IAdvertisingPostsResponse,
  IAdvertisingReportsRequest,
  IAdvertisingRevenueEventDetailRequest,
  IAdvertisingRevenueEventDetailResponse,
  IAdvertisingRevenueEventsRequest,
  IAdvertisingRevenueEventsResponse,
  IAdvertisingState,
  IAdvertisingWalletCreditDetailRequest,
  IAdvertisingWalletCreditDetailResponse,
  IAdvertisingWalletCreditsRequest,
  IAdvertisingWalletCreditsResponse,
} from './types';

export const initialState: IAdvertisingState = {
  loading: false,

  channels: null,
  dashboard: null,

  posts: null,
  post: null,

  reports: null,

  revenueEvents: null,
  revenueEvent: null,

  walletCredits: null,
  walletCredit: null,
};

const advertising = createSlice({
  name: '@@advertising',
  initialState,
  reducers: {
    advertisingInitState: (state) => {
      state.loading = false;
    },

    getAdvertisingChannelsRequest: (
      state,
      _action: PayloadAction<IAdvertisingChannelsRequest | undefined>,
    ) => {
      state.loading = true;
    },
    getAdvertisingChannelsSuccess: (state, action: PayloadAction<IAdvertisingChannelsResponse>) => {
      state.channels = action.payload;
      state.loading = false;
    },

    getAdvertisingDashboardRequest: (
      state,
      _action: PayloadAction<IAdvertisingDashboardRequest | undefined>,
    ) => {
      state.loading = true;
    },
    getAdvertisingDashboardSuccess: (
      state,
      action: PayloadAction<IAdvertisingDashboardResponse>,
    ) => {
      state.dashboard = action.payload;
      state.loading = false;
    },

    getAdvertisingPostsRequest: (
      state,
      _action: PayloadAction<IAdvertisingPostsRequest | undefined>,
    ) => {
      state.loading = true;
    },
    getAdvertisingPostsSuccess: (state, action: PayloadAction<IAdvertisingPostsResponse>) => {
      state.posts = action.payload;
      state.loading = false;
    },

    getAdvertisingPostRequest: (state, _action: PayloadAction<IAdvertisingPostDetailRequest>) => {
      state.loading = true;
    },
    getAdvertisingPostSuccess: (state, action: PayloadAction<IAdvertisingPostDetailResponse>) => {
      state.post = action.payload;
      state.loading = false;
    },

    getAdvertisingReportsRequest: (state, _action: PayloadAction<IAdvertisingReportsRequest>) => {
      state.loading = true;
    },
    getAdvertisingReportsSuccess: (state, action: PayloadAction<Blob>) => {
      state.reports = action.payload;
      state.loading = false;
    },

    getAdvertisingRevenueEventsRequest: (
      state,
      _action: PayloadAction<IAdvertisingRevenueEventsRequest | undefined>,
    ) => {
      state.loading = true;
    },
    getAdvertisingRevenueEventsSuccess: (
      state,
      action: PayloadAction<IAdvertisingRevenueEventsResponse>,
    ) => {
      state.revenueEvents = action.payload;
      state.loading = false;
    },

    getAdvertisingRevenueEventRequest: (
      state,
      _action: PayloadAction<IAdvertisingRevenueEventDetailRequest>,
    ) => {
      state.loading = true;
    },
    getAdvertisingRevenueEventSuccess: (
      state,
      action: PayloadAction<IAdvertisingRevenueEventDetailResponse>,
    ) => {
      state.revenueEvent = action.payload;
      state.loading = false;
    },

    getAdvertisingWalletCreditsRequest: (
      state,
      _action: PayloadAction<IAdvertisingWalletCreditsRequest | undefined>,
    ) => {
      state.loading = true;
    },
    getAdvertisingWalletCreditsSuccess: (
      state,
      action: PayloadAction<IAdvertisingWalletCreditsResponse>,
    ) => {
      state.walletCredits = action.payload;
      state.loading = false;
    },

    getAdvertisingWalletCreditRequest: (
      state,
      _action: PayloadAction<IAdvertisingWalletCreditDetailRequest>,
    ) => {
      state.loading = true;
    },
    getAdvertisingWalletCreditSuccess: (
      state,
      action: PayloadAction<IAdvertisingWalletCreditDetailResponse>,
    ) => {
      state.walletCredit = action.payload;
      state.loading = false;
    },
  },
});

export default advertising.reducer;

export const {
  advertisingInitState,

  getAdvertisingChannelsRequest,
  getAdvertisingChannelsSuccess,

  getAdvertisingDashboardRequest,
  getAdvertisingDashboardSuccess,

  getAdvertisingPostsRequest,
  getAdvertisingPostsSuccess,

  getAdvertisingPostRequest,
  getAdvertisingPostSuccess,

  getAdvertisingReportsRequest,
  getAdvertisingReportsSuccess,

  getAdvertisingRevenueEventsRequest,
  getAdvertisingRevenueEventsSuccess,

  getAdvertisingRevenueEventRequest,
  getAdvertisingRevenueEventSuccess,

  getAdvertisingWalletCreditsRequest,
  getAdvertisingWalletCreditsSuccess,

  getAdvertisingWalletCreditRequest,
  getAdvertisingWalletCreditSuccess,
} = advertising.actions;
